var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GeneralSetting',{staticClass:"c-salutation",attrs:{"label":_vm.$t('settings.userdata.salutation'),"data-key":"salutation","list-translation-key":"settings.userdata.salutations","value-ref":_vm.valueRef}})
}
var staticRenderFns = []

export { render, staticRenderFns }